import React from 'react';
import PropTypes from 'prop-types';
import { components as i18nComponents } from 'mage-i18n';

const DecimalCurrency = ({ value, currency }) => (
  <i18nComponents.Currency value={value / 100} currency={currency} />
);

DecimalCurrency.propTypes = {
  currency: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
};

export default DecimalCurrency;
